import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Tabs } from "@perxis-auto/ui-kit/lib/components/Tabs";
import clsx from "clsx";
import styles from "./Equipments.module.scss.js";
const Equipments = memo(function Equipments2({ isHidden, className, ...props }) {
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsx(Tabs, { destroyInactiveTabPane: true, className: clsx(styles.equipments, className), ...props });
});
export {
  Equipments
};
